import UserWrapper from '../../../../layout/userwrapper/UserWrapper'
import { Box, Paper, Stack, Typography } from '@mui/material'
import React from 'react'
import styles from '../../../../styles/pages/user/content-buyer-accounting.module.scss'
import ContentbuyerAccountingPaymenthistoryTable from '../../../../components/ContentbuyerAccountingPaymenthistoryTable/ContentbuyerAccountingPaymenthistoryTable'
import ContentbuyerPaymentBrackdownCard from '../../../../components/ContentbuyerPaymentBrackdownCard/ContentbuyerPaymentBrackdownCard'
import ContentbuyerAccountingPaymentConfirm from '../../../../components/ContentbuyerAccountingPaymentConfirm/ContentbuyerAccountingPaymentConfirm'
import PerfectScrollbar from "react-perfect-scrollbar"
import "react-perfect-scrollbar/dist/css/styles.css"
import paymentNoitem from '../../../../public/assets/userimages/payment-noitem.svg'

const Accounting = () => {
    return (
        <UserWrapper headerPurchaseBtn={true} footerChatBtn={false}>
            <Paper elevation={0} className={`pageInnerWrapper ${styles.pageAcounting}`}>
                <PerfectScrollbar className={styles.pageAcountScroll}>
                    <Stack direction={'row'} flexWrap={'wrap'} className={styles.accountingWrapper}>
                        <Box className={`${styles.acntLeftsec} ${styles.col}`}>
                            <Box className={`${styles.cmnStyled} ${styles.paymenthistoryBox}`}>
                                <Typography variant='h1' className={styles.boxHeading}>Payments History</Typography>

                                {/* ==================================== */}
                                {/* ========== NO ITEMS START ========== */}
                                {/* ==================================== */}
                                {/* <Box className={styles.paymentnoItem}>
                                    <figure>
                                        <img src={paymentNoitem} alt="" />
                                    </figure>
                                    <Typography variant='body1'>No payments have been processed yet.</Typography>
                                </Box> */}

                                {/* ==================================== */}
                                {/* ========== NO ITEMS START ========== */}
                                {/* ==================================== */}


                                <Box className={styles.tableWrap}>
                                    <ContentbuyerAccountingPaymenthistoryTable />
                                </Box>
                            </Box>
                        </Box>
                        <Box className={`${styles.acntRightsec} ${styles.col}`}>
                            <Box className={styles.rightpanelPad}>
                                <Box className={`${styles.cmnStyled} ${styles.paymentBreakdownBox}`}>
                                    <Typography variant='h1' className={styles.boxHeading}>Up-to-date Payments Breakdown</Typography>
                                    <Box className={styles.paymentbreakdown}>
                                        <ContentbuyerPaymentBrackdownCard />
                                    </Box>
                                </Box>
                                <Box className={`${styles.cmnStyled} ${styles.paymentConfirmBox}`}>
                                    <Typography variant='h1' className={styles.boxHeading}>Payment Confirmation</Typography>

                                    {/* ==================================== */}
                                    {/* ========== NO ITEMS START ========== */}
                                    {/* ==================================== */}
                                    {/* <Box className={styles.confirmationItem}>
                                        <Typography variant='body1'>You have no payments awaiting your confirmation.</Typography>
                                    </Box> */}

                                    {/* ==================================== */}
                                    {/* ========== NO ITEMS START ========== */}
                                    {/* ==================================== */}


                                    <Box className={styles.paymentconfirm}>
                                        <ContentbuyerAccountingPaymentConfirm />
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Stack>
                </PerfectScrollbar>
            </Paper>
        </UserWrapper>
    )
}

export default Accounting